import { EFilenameBlur } from './filename-blur';
import { EFilenameImageBlur } from './filename-blur-data64';

export const getBlurData64 = (filename?: EFilenameBlur): string => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
  return filename ? ((EFilenameImageBlur as any)[filename] as string) : null;
};
